// extracted by mini-css-extract-plugin
export default {"text-align-left":"text-align-left__Z+Fcu","icon-class":"icon-class__P5J-C","card":"card__A9ytV"};